export default __webpack_public_path__ + "static/media/roma-logo-half.c378273f.png";